<template>
  <div class="quick-wrap" v-show="show" @touchmove.prevent>
    <div class="quick-order">
      <div class="icon-close" @click="close">
        <span class="iconfont icon1">&#xe614;</span>
        <span class="iconfont icon2">&#xe606;</span>
      </div>
      <div class="quick-title-wrapper">
        <div class="quick-title">Amount verification</div>
      </div>
      <div class="content-wrap">
        <div class="warning">
          <div class="text">* {{L.verifyNotice1}}</div>
          <div class="text">* {{L.verifyNotice2}}</div>
          <div class="text">* {{L.verifyNotice3}}</div>
          <div class="text">* {{L.verifyNotice4}}</div>
        </div>
        <div class="notice">{{L.verifyNotice5}}</div>
        <AddNumber
          :showAdd="false" 
          paddingTopBottom="7px" 
          v-model="checkNumber" 
          @blur="e=>blurAmount(e)" 
        />
      </div>
      
      <div class="btn-wrapper">
        <div class="btn-wrap" @click="handleConfirm" v-loading="loading">
          <span>{{L.confirm}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {api_auth_amount_verify} from '@/api/api'
import {postAction} from '@/api/tool'
import AddNumber from '@/components/AddNumber'

export default {
  name:'Verify',
  components:{
    AddNumber
  },
  data() {
    return {
      loading:false,
      show:false,
      checkNumber:0
    }
  },
  methods:{
    open(){
      this.checkNumber=0
      this.show=true
    },
    close(){
      this.show=false
    },
    blurAmount(e){
      this.checkNumber=Number(e.toFixed(2))
    },
    handleConfirm(){
      if(this.checkNumber<=0){
        this.$message.warning('Please enter a number greater than 0.')
        return
      }
      let params = {
        checkNumber:this.checkNumber
      }
      this.loading=true
      postAction(api_auth_amount_verify,params).then(()=>{
        this.loading=false
        this.$message.success('Verify successfully')
        this.close()
        this.$emit('getAuth')
      }).catch(()=>{
        this.loading=false
      })
      
    }
  }
}
</script>

<style lang="less" scoped>
@import url('../../../public/css/public.less');
/* 快速下单 */
.quick-wrap{
  position: fixed;
  left:0;
  top:0;
  width:100%;
  height:100%;
  z-index: 999;
  background-color: rgba(0,0,0,0.6);
  overflow: hidden;
  .quick-order{
    padding:30px 0;
    border-radius: 2px;
    position: absolute;
    &:extend(.main-box-shadow);
    width:600px;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background-color: #fff;
    box-sizing: border-box;
    text-align: left;
    .icon-close{
      position: absolute;
      right:14px;
      top:14px;
      .icon1{
        font-size: 24px;
        display: block;
        color:#888;
      }
      .icon2{
        font-size: 24px;
        display: none;
        color:@mainColor;
      }
      &:hover{
        cursor: pointer;
        .icon1{
          display: none;
        }
        .icon2{
          display: block;
        }
      }
    }
    .quick-title-wrapper{
      padding:0 40px 20px 40px;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 26px;
      color:@mainColor;
      border-bottom: 1px solid @inpBorderClolr;
      // padding-bottom: 20px;
      // padding-top: 10px;
      .quick-title{
        // background-color: red;
        text-align: center;
      }
    }
    .content-wrap{
      padding:0 40px;
      .warning{
        color:@dangerColor;
      }
      .text{
        margin-bottom: 10px;
      }
      .notice{
        color:@mainColor;
        margin-top: 18px;
        margin-bottom: 6px;
      }
    }
    
    .btn-wrapper{
      padding:0 40px;
      .btn-wrap{
        font-size: 12px;
        margin-top: 26px;
        text-align: center;
        width:100%;
        color:#fff;
        background-color: @mainColor;
        padding:8px 6px;
        box-sizing: border-box;
        border:1px solid @mainColor;
        border-radius: 2px;
        &:extend(.transtion-time);
        &:hover{
          cursor: pointer;
          color:@mainColor;
          background-color: #fff;
          &:extend(.transtion-time);
        }
      }
    }
    
  }
}

</style>